import React from 'react';
import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import TableActions from 'portaltransparencia-common/components/TableActions.react';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';

export default class SuspensaoFornecedoresTable extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    searchWithPage: PropTypes.func.isRequired
  };

  renderFornecedores = fornecedores => {
    const key = `${fornecedores.get('pessoa')}`;

    return (
      <TableActions ref="row" key={key} data={fornecedores}>
        <td id="tableNome">{fornecedores.get('nome')}</td>
        <td id="tableCnpjCpf">{fornecedores.get('cnpjCpf')}</td>
        <td id="tableDataIniSuspensao">
          {DateUtils.transform(fornecedores.get('dataIniSuspensao')) ||
            'Data não informada'}
        </td>
        <td id="tableDataFinSuspensao">
          {DateUtils.transform(fornecedores.get('dataFinSuspensao')) ||
            'Data não informada'}
        </td>
      </TableActions>
    );
  };

  render() {
    const { page, searchWithPage } = this.props;
    let fornecedores = page.get('content');

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader
            empty={fornecedores.isEmpty()}
            text="Não foi encontrado nenhum fornecedor para a pesquisa selecionada."
          >
            <tr>
              <TableHeaderItem
                field="nome"
                label="Nome"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field="cnpjCpf"
                label="CNPJ/CPF"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field="dataIniSuspensao"
                label="Dt. Início Suspensão"
                page={page}
                searchWithPage={searchWithPage}
              />
              <TableHeaderItem
                field="dataFinSuspensao"
                label="Dt. Final Suspensão"
                page={page}
                searchWithPage={searchWithPage}
              />
            </tr>
          </TableHeader>

          <tbody>{fornecedores.map(this.renderFornecedores)}</tbody>
        </table>
      </div>
    );
  }
}
